<section class="row mappings-container">
  <div class="col col-12 toolbar-container" *ngIf="enableToolbar">
    <ion-toolbar>
      <ion-title class="page-title p-0">
        <span [innerText]="menuItemMappings?.length"></span> <span translate="FOOD_ITEMS" class="mx-2"></span>
      </ion-title>
      <section class="actions" slot="end" *ngIf="!forCustomer">
        <ion-button fill="outline" class="ion-text-capitalize" (click)="onAddItemClick()" translate="UPDATE">
          <ion-icon slot="start" name="link-sharp"></ion-icon>
        </ion-button>
      </section>
    </ion-toolbar>
    <ng-content select="[header]"></ng-content>
  </div>

  <ion-card *ngFor="let mapping of menuItemMappings; let i = index;" lines="full"
    class="col col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 item-with-borders mapping">
    <ng-container *ngIf="mapping.menuItemEntity as item">
      <div class="thumbnail" *ngIf="item.iconImage else elsePreview" [style.background-image]="'url(' + item.iconImage.url + ')'">
        <app-food-type-indicator [ngClass]="item.vegetarian ? 'veg' : 'non-veg'"></app-food-type-indicator>
      </div>
      <ng-template #elsePreview>
        <div class="thumbnail">
          <app-food-type-indicator [ngClass]="item.vegetarian ? 'veg' : 'non-veg'"></app-food-type-indicator>
        </div>
      </ng-template>

      <ion-card-header class="ion-text-capitalize">
        <ion-card-title class="mt-2" [innerText]="item.name"></ion-card-title>
        <ion-card-subtitle class="tags" *ngIf="item.tags?.length">
          <ion-icon name="pricetags-outline"></ion-icon>
          <span [innerText]="item.tags?.join(', ')"></span>
        </ion-card-subtitle>
        <ion-card-subtitle *ngIf="restaurantBranchId" class="price" [ngClass]="{'no-pointer': forCustomer}" (click)="onPriceEditClick($event, mapping, 'price')">
          <span>Price: </span>
          <ng-container *ngIf="mapping?.priceDetails?.active">
            <span class="color-dark amount" *ngIf="mapping?.priceDetails?.price as price">{{mapping?.priceDetails?.currencyModel?.currencysymbol}} <span [innerText]="price"></span></span>
          </ng-container>
          <span class="color-danger" *ngIf="!mapping?.priceDetails?.active || !mapping?.priceDetails?.price"><b>Unavailable</b></span>
        
        </ion-card-subtitle>
        <ion-card-subtitle *ngIf="restaurantBranchId && !forCustomer" class="stock">
          <button (click)="onPriceEditClick($event, mapping, 'stock')">
            <span> Stock - </span>
            <span *ngIf="mapping.stockDetails else noStock">
              Available: <span class="color-dark" [innerText]="mapping.stockDetails.availableQuantity"></span>,
              Reserved: <span class="color-dark" [innerText]="mapping.stockDetails.reservedQuantity"></span>
              Planned: <span class="color-dark" [innerText]="mapping.stockDetails.totalQuantity"></span>
            </span>
            <ng-template #noStock>
              <span class="color-danger" *ngIf="!mapping?.priceDetails?.price"><b>Unavailable</b></span>
            </ng-template>
            <ion-icon class="edit-icon" src="assets/icons/edit_24dp.svg"></ion-icon>
          </button>
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <div class="description" [innerText]="item.description"></div>
      </ion-card-content>

      <div class="p-3 ion-text-center cart-mgmt" *ngIf="forCustomer && mapping?.priceDetails?.price && mapping.cartItem">
        <app-quantity-selector [value]="mapping.cartItem?.quantity" (change)="onQuantityChange($event, mapping)"></app-quantity-selector>
      </div>
    </ng-container>
  </ion-card>

  <ng-container *ngIf="!menuItemMappings?.length">
    <ion-list class="no-data-section">
      <ion-item lines="none" class="ion-text-center">
        <ion-label>No Items to Display!</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
</section>

